import { render, staticRenderFns } from "./supplierlist.vue?vue&type=template&id=274c403b&scoped=true&"
import script from "./supplierlist.vue?vue&type=script&lang=js&"
export * from "./supplierlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c403b",
  null
  
)

export default component.exports